export default __webpack_public_path__ + "static/media/facil5.29e38934.png";